import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = { class: "pdf-generator" }
const _hoisted_2 = ["disabled"]
const _hoisted_3 = {
  key: 0,
  class: "spinner-grow spinner-grow-sm me-2",
  role: "status",
  "aria-hidden": "true"
}
const _hoisted_4 = {
  key: 1,
  class: "fas fa-file-pdf me-2"
}
const _hoisted_5 = {
  class: "modal fade",
  id: "pdfPreviewModal",
  tabindex: "-1",
  "aria-hidden": "true",
  ref: "pdfModal"
}
const _hoisted_6 = { class: "modal-dialog modal-xl" }
const _hoisted_7 = { class: "modal-content" }
const _hoisted_8 = { class: "modal-header" }
const _hoisted_9 = { class: "modal-body" }
const _hoisted_10 = {
  key: 0,
  class: "text-center py-5"
}
const _hoisted_11 = {
  key: 1,
  class: "pdf-preview"
}
const _hoisted_12 = ["innerHTML"]
const _hoisted_13 = {
  key: 2,
  class: "text-center py-5"
}
const _hoisted_14 = { class: "modal-footer" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("button", {
      type: "button",
      onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.generatePDF && _ctx.generatePDF(...args))),
      class: "btn btn-info btn-lg me-3",
      disabled: _ctx.isGenerating
    }, [
      (_ctx.isGenerating)
        ? (_openBlock(), _createElementBlock("span", _hoisted_3))
        : _createCommentVNode("", true),
      (!_ctx.isGenerating)
        ? (_openBlock(), _createElementBlock("i", _hoisted_4))
        : _createCommentVNode("", true),
      _createTextVNode(" " + _toDisplayString(_ctx.isGenerating ? 'Génération...' : 'Aperçu PDF'), 1)
    ], 8, _hoisted_2),
    _createElementVNode("div", _hoisted_5, [
      _createElementVNode("div", _hoisted_6, [
        _createElementVNode("div", _hoisted_7, [
          _createElementVNode("div", _hoisted_8, [
            _cache[4] || (_cache[4] = _createElementVNode("h5", { class: "modal-title" }, [
              _createElementVNode("i", { class: "fas fa-file-pdf me-2" }),
              _createTextVNode("Aperçu du Formulaire de Recensement ")
            ], -1)),
            _createElementVNode("button", {
              type: "button",
              class: "btn-close",
              onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.closeModal && _ctx.closeModal(...args))),
              "aria-label": "Close"
            })
          ]),
          _createElementVNode("div", _hoisted_9, [
            (_ctx.isGenerating)
              ? (_openBlock(), _createElementBlock("div", _hoisted_10, [...(_cache[5] || (_cache[5] = [
                  _createElementVNode("div", {
                    class: "spinner-border text-primary",
                    role: "status"
                  }, [
                    _createElementVNode("span", { class: "visually-hidden" }, "Génération du PDF...")
                  ], -1),
                  _createElementVNode("p", { class: "mt-3" }, "Génération de l'aperçu PDF en cours...", -1)
                ]))]))
              : (_ctx.pdfContent)
                ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                    _createElementVNode("div", {
                      class: "pdf-content",
                      innerHTML: _ctx.pdfContent
                    }, null, 8, _hoisted_12)
                  ]))
                : (_openBlock(), _createElementBlock("div", _hoisted_13, [...(_cache[6] || (_cache[6] = [
                    _createElementVNode("i", { class: "fas fa-file-pdf fs-1 text-muted" }, null, -1),
                    _createElementVNode("p", { class: "mt-3 text-muted" }, "Cliquez sur \"Aperçu PDF\" pour générer l'aperçu", -1)
                  ]))]))
          ]),
          _createElementVNode("div", _hoisted_14, [
            _createElementVNode("button", {
              type: "button",
              class: "btn btn-secondary",
              onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.closeModal && _ctx.closeModal(...args)))
            }, [...(_cache[7] || (_cache[7] = [
              _createElementVNode("i", { class: "fas fa-times me-2" }, null, -1),
              _createTextVNode("Fermer ", -1)
            ]))]),
            (_ctx.pdfContent)
              ? (_openBlock(), _createElementBlock("button", {
                  key: 0,
                  type: "button",
                  onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.printPDF && _ctx.printPDF(...args))),
                  class: "btn btn-primary"
                }, [...(_cache[8] || (_cache[8] = [
                  _createElementVNode("i", { class: "fas fa-print me-2" }, null, -1),
                  _createTextVNode("Imprimer ", -1)
                ]))]))
              : _createCommentVNode("", true)
          ])
        ])
      ])
    ], 512)
  ]))
}